export const config = {
  API_URL: 'https://minerva-learning.herokuapp.com/api/'
};
